import { useTranslation } from "@msuite/ui/localization";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { TeamPicker } from "@/components/pickers/team-picker";
import type { TeamPickerController } from "@/hooks/use-team-picker";
import { useAbsencesCalendarContext } from "./context";
import { Calendar } from "@msuite/ui/calendar";

/** Props Interface */
interface AbsencesCalendarControlsProps {
	teamPickerController: TeamPickerController;
}

export function AbsencesCalendarControls({ teamPickerController }: AbsencesCalendarControlsProps) {
	/** Context */
	const { controller } = useAbsencesCalendarContext();
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="h-stack justify-between">
			<TeamPicker controller={teamPickerController} />
			<div className="h-stack">
				<SegmentedControl
					value={controller.mode}
					items={[
						{
							label: t("dates.week"),
							value: "week",
							cyId: "absences-controller-mode-week",
						},
						{
							label: t("dates.month"),
							value: "month",
							cyId: "absences-controller-mode-month",
						},
						{
							label: t("dates.quarter"),
							value: "quarter",
							cyId: "absences-controller-mode-quarter",
						},
						{
							label: t("dates.year"),
							value: "year",
							cyId: "absences-controller-mode-year",
						},
					]}
					onChange={controller.setMode}
				/>
				<Calendar.Controls
					onBack={controller.onBack}
					onForward={controller.onForward}
					isAttached={false}
					buttonProps={{ size: "xxs", variant: "white" }}
				/>
			</div>
		</div>
	);
}
